/**
 * Cleans the `pair` field inside params by removing any items
 * whose `make` is not included in the allowedMakes list.
 *
 * - Keeps only valid makes (case-insensitive)
 * - Removes the `pair` field completely if nothing valid remains
 *
 * @param {Object} params
 * @param {Array<string>} allowedMakes
 * @returns {Object} updated params
 */
export function sanitizePairParam(params = {}, allowedMakes = []) {
  const nextParams = { ...params };

  const pair = Array.isArray(nextParams.pair) ? nextParams.pair : [];

  if (!pair.length || !allowedMakes.length) {
    return nextParams;
  }

  const normalizedAllowed = allowedMakes.map((m) => m.toUpperCase());

  const filteredPair = pair.filter((item) => {
    const make = item?.make;
    return typeof make === 'string' && normalizedAllowed.includes(make.toUpperCase());
  });

  if (filteredPair.length) {
    nextParams.pair = filteredPair;
  } else {
    delete nextParams.pair;
  }

  return nextParams;
}
